import React from 'react';

import FooterRoute, { FooterRouteProps } from './FooterRoute';
import {
  AuthenticateHatPage,
  EmailVerificationPage,
  LandingPage,
  RegistrationAuthenticateHatPage,
  RegistrationErrorPage,
  SignupPage,
} from '../../pages';

import { RouterPaths } from '../../constants/routes';

const HomeRoutes: FooterRouteProps[] = [
  {
    Component: LandingPage,
    exact: true,
    path: RouterPaths.home,
  },
  {
    Component: AuthenticateHatPage,
    path: RouterPaths.authenticateHat,
  },
  {
    Component: SignupPage,
    path: RouterPaths.signup,
  },
  {
    Component: RegistrationAuthenticateHatPage,
    path: RouterPaths.authenticateSignup,
  },
  {
    Component: EmailVerificationPage,
    path: RouterPaths.authenticateSuccess,
  },
  {
    Component: RegistrationErrorPage,
    path: RouterPaths.signupError,
  },
];

const HomeNavigator = HomeRoutes.map((route) => <FooterRoute key={route.path} {...route} />);

export default HomeNavigator;
